export class NodeStateService
{
    private collapsedNodes: Set<string> = new Set();

    toggleCollapse(nodeId: string): void
    {
        if (this.collapsedNodes.has(nodeId))
        {
            this.collapsedNodes.delete(nodeId);
        }
        else
        {
            this.collapsedNodes.add(nodeId);
        }
    }

    isCollapsed(nodeId: string): boolean
    {
        return this.collapsedNodes.has(nodeId);
    }

    collapseAll(nodeIds: string[]): void
    {
        nodeIds.forEach(id => this.collapsedNodes.add(id));
    }

    expandAll(): void
    {
        this.collapsedNodes.clear();
    }
}
